// 비밀번호 입력 + 표시/숨김 토글(눈 아이콘)
import { useState } from 'preact/hooks';

interface Props {
  value: string;
  onValue: (v: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export function PasswordInput({ value, onValue, placeholder, autoFocus }: Props) {
  const [show, setShow] = useState(false);
  return (
    <div class="pw">
      <input
        class="input pw__input"
        type={show ? 'text' : 'password'}
        value={value}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onInput={(e) => onValue((e.target as HTMLInputElement).value)}
      />
      <button
        type="button"
        class="pw__toggle"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? '비밀번호 숨기기' : '비밀번호 보기'}
        title={show ? '숨기기' : '보기'}
        tabIndex={-1}
      >
        {show ? '🙈' : '👁️'}
      </button>
    </div>
  );
}
